<template>
    <v-container>

        <v-row>
            <v-col>
                <div class="headline">Simkort</div>
                <br>

                <v-btn color="success" sx2 @click="openNewSIM">
                    <v-icon left>mdi-plus-circle-outline</v-icon>
                    Ny simkort
                </v-btn>

                <v-row>
                    <v-col>
                        <v-data-table :items="simcards" :headers="headers" :loading="simcardsLoading" hide-default-footer :items-per-page="-1" :mobile-breakpoint="0">
                            <template v-slot:item="{item}">
                                <tr @click="openEditSIM(item)" style="cursor:pointer; white-space: nowrap">
                                    <td>(+47) {{item.number}}</td>
                                    <td>{{item.ccid}}</td>
                                    <td>{{item.operator}}</td>
                                    <td>{{item.gate? `${item.gate.name} - ${item.gate.direction == 2 ? 'TOVEIS' : (item.gate.direction == 0 ? 'INN' : 'UT')}`: '-'}}</td>
                                    <td>
                                        <div class="d-flex">
                                            <v-btn @click.stop="openEditSIM(item)" icon>
                                                <v-icon color="primary">mdi-pencil</v-icon>
                                            </v-btn>
                                            <v-btn @click.stop="openDeleteSIM(item)" icon>
                                                <v-icon color="primary">mdi-delete</v-icon>
                                            </v-btn>
                                        </div>

                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <v-dialog v-model="newSIM.show" persistent max-width="500">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    Ny enhet:
                </v-card-title>
                <v-card-text>
                    <v-form ref="newSIMForm">
                        <v-text-field v-model="newSIM.sim.number" label="Nummer*" :rules="[v => !!v || 'Påkrevd']"></v-text-field>
                        <v-text-field v-model="newSIM.sim.ccid" label="CCID*" :rules="[v => !!v || 'Påkrevd']"></v-text-field>
                        <v-text-field v-model="newSIM.sim.operator" label="Nettverk"></v-text-field>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="closeNewSIM">Avbryt</v-btn>
                    <v-btn @click="saveNewSIM" :loading="newSIM.loading" color="primary">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="editSIM.show" persistent max-width="500">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    Rediger enhet:
                </v-card-title>
                <v-card-text>
                    <v-form ref="editSIMForm">
                        <v-text-field v-model="editSIM.sim.number" label="Nummer*" :rules="[v => !!v || 'Påkrevd']"></v-text-field>
                        <v-text-field v-model="editSIM.sim.ccid" label="CCID*" :rules="[v => !!v || 'Påkrevd']"></v-text-field>
                        <v-text-field v-model="editSIM.sim.operator" label="Nettverk"></v-text-field>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="closeEditSIM">Avbryt</v-btn>
                    <v-btn @click="saveEditSIM" :loading="editSIM.loading" color="primary">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="deleteSIM.show" max-width="500">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    Slett SIM-kort: {{deleteSIM.sim ? deleteSIM.sim.number : ''}}
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="closeDeleteSIM">Avbryt</v-btn>
                    <v-btn @click="confirmDeleteSIM" :loading="deleteSIM.loading" color="primary">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
// import axios from "axios";
export default {
    data() {
        return {
            gates: [],
            simcards: [],
            simcardsLoading: false,
            headers: [
                { text: "Nummer", value: "number", sortable: true },
                { text: "CCID", value: "ccid", sortable: true },
                { text: "Operator", value: "operator", sortable: false },
                { text: "Port", value: "port", sortable: false },
                { text: "Handlinger", sortable: false }
            ],
            newSIM: {
                show: false,
                loading: false,
                sim: {
                    id: 0,
                    number: "",
                    ccid: "",
                    operator: ""
                }
            },
            editSIM: {
                show: false,
                loading: false,
                sim: {
                    id: 0,
                    number: "",
                    ccid: "",
                    operator: ""
                }
            },
            deleteSIM: {
                show: false,
                loading: false,
                sim: {
                    id: 0,
                    number: "",
                    ccid: "",
                    operator: ""
                }
            }
        };
    },
    methods: {
        openNewSIM: function() {
            this.newSIM.show = true;
        },
        closeNewSIM: function() {
            this.newSIM.sim.number = "";
            this.newSIM.sim.ccid = "";
            this.newSIM.sim.operator = "";
            this.newSIM.show = false;
        },
        saveNewSIM: function() {
            if (this.$refs.newSIMForm.validate()) {
                this.newSIM.loading = true;
                this.axios
                    .put(`/simcard`, this.newSIM.sim)
                    .then(response => {
                        if (response.data.success) {
                            this.simcards.push(response.data.data);
                            this.$store.commit("snackbar", {
                                text: `SIM-kort laget.`,
                                color: "success",
                                show: true
                            });
                        } else {
                            this.$store.commit("snackbar", {
                                text: `SIM-kort ikke laget.`,
                                color: "error",
                                show: true
                            });
                        }
                    })
                    .catch(() => {
                        this.$store.commit("snackbar", {
                            text: `SIM-kort ikke laget.`,
                            color: "error",
                            show: true
                        });
                    })
                    .finally(() => {
                        this.newSIM.loading = false;
                        this.closeNewSIM();
                    });
            }
        },
        openDeleteSIM: function(simcard) {
            this.deleteSIM.sim.id = simcard.id;
            this.deleteSIM.sim.number = simcard.number;
            this.deleteSIM.sim.ccid = simcard.ccid;
            this.deleteSIM.sim.operator = simcard.operator;
            this.deleteSIM.show = true;
        },
        closeDeleteSIM: function() {
            this.deleteSIM.sim.id = 0;
            this.deleteSIM.sim.number = "";
            this.deleteSIM.sim.ccid = "";
            this.deleteSIM.sim.operator = "";

            this.deleteSIM.show = false;
        },
        confirmDeleteSIM: function() {
            this.deleteSIM.loading = true;
            this.axios
                .delete(`/simcard/${this.deleteSIM.sim.id}`)
                .then(response => {
                    if (response.data.success) {
                        let index = this.simcards.findIndex(s => s.id === this.deleteSIM.sim.id);
                        if (index >= 0) {
                            this.simcards.splice(index, 1);
                            this.$store.commit("snackbar", {
                                text: `SIM-kort slettet.`,
                                color: "success",
                                show: true
                            });
                        }
                    } else {
                        this.$store.commit("snackbar", {
                            text: `SIM-kort ikke slettet.`,
                            color: "error",
                            show: true
                        });
                    }
                })
                .catch(() => {
                    this.$store.commit("snackbar", {
                        text: `SIM-kort ikke slettet.`,
                        color: "error",
                        show: true
                    });
                })
                .finally(() => {
                    this.deleteSIM.loading = false;
                    this.closeDeleteSIM();
                });
        },
        openEditSIM: function(sim) {
            this.editSIM.sim.id = sim.id;
            this.editSIM.sim.number = sim.number;
            this.editSIM.sim.ccid = sim.ccid;
            this.editSIM.sim.operator = sim.operator;
            this.editSIM.show = true;
        },
        closeEditSIM: function() {
            this.editSIM.sim.id = 0;
            this.editSIM.sim.number = "";
            this.editSIM.sim.ccid = "";
            this.editSIM.sim.operator = "";
            this.editSIM.show = false;
        },
        saveEditSIM: function() {
            if (this.$refs.editSIMForm.validate()) {
                this.editSIM.loading = true;
                this.axios
                    .post(`/simcard/${this.editSIM.sim.id}`, this.editSIM.sim)
                    .then(response => {
                        if (response.data.success) {
                            let sim = this.simcards.find(s => s.id === this.editSIM.sim.id);
                            sim.number = response.data.data.number;
                            sim.ccid = response.data.data.ccid;
                            sim.operator = response.data.data.operator;

                            this.$store.commit("snackbar", {
                                text: `SIM-kort redigert.`,
                                color: "success",
                                show: true
                            });
                        } else {
                            this.$store.commit("snackbar", {
                                text: `SIM-kort ikke redigert.`,
                                color: "error",
                                show: true
                            });
                        }
                    })
                    .catch(() => {
                        this.$store.commit("snackbar", {
                            text: `SIM-kort ikke redigert.`,
                            color: "error",
                            show: true
                        });
                    })
                    .finally(() => {
                        this.editSIM.loading = false;
                        this.closeEditSIM();
                    });
            }
        }
    },
    async mounted() {
        this.simcardsLoading = true;
        await this.axios
            .get(`/simcard`)
            .then(response => {
                if (response.data.success) {
                    this.simcards = response.data.data.map(sim => {
                        sim.gate = null;
                        return sim;
                    });
                } else {
                    this.$store.commit("snackbar", {
                        text: `SIM-kort ikke hentet fra DB.`,
                        color: "error",
                        show: true
                    });
                }
            })
            .catch(() => {
                this.$store.commit("snackbar", {
                    text: `SIM-kort ikke hentet fra DB.`,
                    color: "error",
                    show: true
                });
            })
            .finally(() => {});

        let params = {};
        Object.assign(params, this.axios.defaults.params);
        params.includes = "unit.simcard";

        this.axios
            .get(`/gate`, { params: params })
            .then(response => {
                if (response.data.success) {
                    this.gates = response.data.data;
                    this.gates.forEach(g => {
                        let gate = g;
                        let unit = null;
                        let simcard = null;

                        unit = gate.unit;
                        if (unit.simcard) {
                            simcard = unit.simcard;
                        }

                        let sim = this.simcards.find(s => s.id === simcard.id);
                        if (sim) {
                            sim.gate = gate;
                        }
                    });
                } else {
                    this.$store.commit("snackbar", {
                        text: `Portene ikke hentet fra DB.`,
                        color: "error",
                        show: true
                    });
                }
            })
            .catch(() => {
                this.$store.commit("snackbar", {
                    text: `Portene ikke hentet fra DB.`,
                    color: "error",
                    show: true
                });
            })
            .finally(() => {
                // this.simcardsLoading = false;
                this.simcards.sort((a, b) => {
                    if (!a.gate || !b.gate) return 0;

                    if (a.gate.name < b.gate.name) return -1;
                    else if (a.gate.name > b.gate.name) return 1;
                    else return 0;
                });
                this.simcardsLoading = false;
            });
    },
    beforeRouteEnter(to, from, next) {
        next(vue => {
            vue.$store.commit("showAppBar", true);
            vue.$store.commit("showNavDrawer", true);
        });
    },
};
</script>
 <style lang="scss" scoped>
</style>
 